// ink-component
import React, { useContext } from 'react';
import { Tooltip } from '../../../Tooltip/Tooltip';
import { SideNavContext } from '../../SideNavContext';
import getGlobalProps from '../../../../helpers/constants/global-props';
import { IconProps } from '../../../Icon/Icon';
import { SideNavGroupToggleContent } from './SideNavGroupToggleContent';

export type SideNavGroupToggleProps = {
  /** Modifier for always showing child menu items */
  alwaysShowMenuItems?: boolean;
  /** Modifier for showing child menu items */
  showMenuItems?: boolean;
  /** Group title text */
  title: string;
  /** Group toggle icon type */
  icon: IconProps['type'];
  /** Badged state modifier */
  isBadged?: boolean;
  /** Active state modifier */
  isActive?: boolean;
  /** onClick callback, sends the event */
  onClick?: () => void;
  /** Marks the element with a given ID to make it easier to select it on tests */
  'data-testid'?: string | number;
};

/**
 * @purpose Group toggle element
 * @group SideNav
 * @categories navigation
 */
const SideNavGroupToggle = (props: SideNavGroupToggleProps) => {
  const { isClosed } = useContext(SideNavContext);
  const { title, 'data-testid': dataTestId } = props;
  const globalProps = getGlobalProps({});

  return (
    <Tooltip
      noDelay
      preventClickPersist
      triggerIsBlock
      isShowing={isClosed}
      trigger={<SideNavGroupToggleContent {...props} />}
      {...globalProps}
      data-testid={dataTestId}
    >
      {title}
    </Tooltip>
  );
};

SideNavGroupToggle.displayName = 'SideNav.GroupToggle';

export default SideNavGroupToggle;
